import IAdditionStyle from '../../models/IAdditionStyle';

export enum TooltipPosition {
  TopLeft = 'TopLeft',
  TopRight = 'TopRight',
  BottomLeft = 'BottomLeft',
  BottomRight = 'BottomRight',
  Center = 'Center',
}

export interface ITooltip {
  className?: string;
  dataAt: string;
  toggler?: React.ReactNode;
  position?: TooltipPosition;
  width?: string;
  arrow?: boolean;
  height?: string;
  maxWidth?: string;
  minWidth?: string;
  maxHeight?: string;
  minHeight?: string;
  style?: IAdditionStyle;
  backgroundColor?: string;
  borderColor?: string;
  contentColor?: string;
  lineHeight?: string;
  boxShadow?: string;
  children?: React.ReactNode;
}
